<template>
  <div class="modal-overlay" v-if="visible" @click.self="$emit('cancel')">
    <div class="modal-card form-modal">
      <h2 class="modal-title">{{ isEditing ? 'Editar Participante' : 'Novo Participante' }}</h2>

      <form @submit.prevent="handleSubmit" class="participant-form">
        <div class="form-row">
          <div class="form-group">
            <label class="label">Nome *</label>
            <input class="input" type="text" v-model="form.name" placeholder="Nome completo" />
            <span class="error-msg" v-if="errors.name">{{ errors.name }}</span>
          </div>
          <div class="form-group form-sm">
            <label class="label">Idade</label>
            <input class="input" type="number" v-model="form.age" min="0" max="150" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="label">Lider</label>
            <input class="input" type="text" v-model="form.leader" placeholder="Nome do lider" />
          </div>
          <div class="form-group">
            <label class="label">Celula</label>
            <input class="input" type="text" v-model="form.celula" placeholder="Nome da celula" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="label">Celular</label>
            <input class="input" type="tel" v-model="form.number" placeholder="(XX) XXXXX-XXXX" />
          </div>
          <div class="form-group">
            <label class="label">Celular Responsavel</label>
            <input class="input" type="tel" v-model="form.numberFamily" placeholder="(XX) XXXXX-XXXX" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="label">Responsavel</label>
            <input class="input" type="text" v-model="form.responsavel" placeholder="Nome do responsavel" />
          </div>
          <div class="form-group">
            <label class="label">Contato Responsavel</label>
            <input class="input" type="tel" v-model="form.contatoResponsavel" placeholder="(XX) XXXXX-XXXX" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="label">Cidade</label>
            <input class="input" type="text" v-model="form.city" placeholder="Cidade" />
          </div>
          <div class="form-group">
            <label class="label">Igreja</label>
            <input class="input" type="text" v-model="form.church" placeholder="Igreja" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="label">Valor Total (R$)</label>
            <input class="input" type="number" v-model="form.valorTotal" min="0" step="0.01" placeholder="0.00" />
          </div>
          <div class="form-group">
            <label class="label">Valor Pago (R$)</label>
            <input class="input" type="number" v-model="form.valorPago" min="0" step="0.01" placeholder="0.00" />
          </div>
          <div class="form-group">
            <label class="label">Data Pagamento</label>
            <input class="input" type="text" v-model="form.dataPagamento" placeholder="Ex: 05/04, PAGO..." />
          </div>
        </div>

        <div class="form-group">
          <label class="label">Possui alergia ou usa medicacao?</label>
          <div class="radio-group">
            <label class="radio-label"><input type="radio" value="false" v-model="hasAllergy" /> Nao</label>
            <label class="radio-label"><input type="radio" value="true" v-model="hasAllergy" /> Sim</label>
          </div>
        </div>
        <div class="form-group" v-if="hasAllergy === 'true'">
          <label class="label">Descreva</label>
          <textarea class="input textarea" v-model="form.allergy" placeholder="Detalhes da alergia/medicacao"></textarea>
        </div>

        <div class="form-row">
          <div class="form-group form-sm">
            <label class="label">Volumes (bagagem)</label>
            <input class="input" type="number" v-model="form.baggage" min="0" />
          </div>
          <div class="form-group">
            <label class="label">Quarto</label>
            <input class="input" type="text" v-model="form.quarto" placeholder="Ex: Azul, 101, Masculino A..." />
          </div>
        </div>

        <div class="form-group">
          <label class="label">Fotos da mala</label>
          <div class="baggage-photos">
            <div class="photo-slot" v-for="(photo, idx) in existingPhotos" :key="'e-' + idx">
              <button type="button" class="photo-open" @click="openLightbox(photo.url)" aria-label="Ver foto ampliada">
                <img :src="photo.url" alt="Mala" class="photo-preview" />
              </button>
              <button type="button" class="photo-remove" @click="removeExistingPhoto(idx)" aria-label="Remover foto">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"/></svg>
              </button>
            </div>
            <div class="photo-slot" v-for="(photo, idx) in newPhotos" :key="'n-' + idx">
              <button type="button" class="photo-open" @click="openLightbox(photo.preview)" aria-label="Ver foto ampliada">
                <img :src="photo.preview" alt="Mala" class="photo-preview" />
              </button>
              <button type="button" class="photo-remove" @click="removeNewPhoto(idx)" aria-label="Remover foto">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"/></svg>
              </button>
            </div>
            <label class="photo-slot photo-add" v-if="totalPhotos < 2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5z"/></svg>
              <span>Adicionar</span>
              <input type="file" accept="image/*" capture="environment" class="file-input-hidden" @change="onPhotoSelected" />
            </label>
          </div>
        </div>

        <div class="modal-actions">
          <button type="button" class="btn-secondary" @click="$emit('cancel')">Cancelar</button>
          <button type="submit" class="btn-primary">{{ isEditing ? 'Salvar' : 'Cadastrar' }}</button>
        </div>
      </form>
    </div>

    <div class="photo-lightbox" v-if="lightboxSrc" @click="closeLightbox">
      <button type="button" class="lightbox-close" @click.stop="closeLightbox" aria-label="Fechar foto">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"/></svg>
      </button>
      <img :src="lightboxSrc" alt="Foto da mala" class="lightbox-image" @click.stop />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParticipantForm',
  props: {
    visible: { type: Boolean, default: false },
    participant: { type: Object, default: null }
  },
  emits: ['save', 'cancel'],
  data() {
    return {
      form: this.getEmptyForm(),
      hasAllergy: 'false',
      errors: {},
      existingPhotos: [],
      newPhotos: [],
      removedPublicIds: [],
      lightboxSrc: null
    }
  },
  computed: {
    isEditing() { return !!this.participant },
    totalPhotos() { return this.existingPhotos.length + this.newPhotos.length }
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.participant) {
          this.form = { ...this.participant }
          this.hasAllergy = this.participant.allergy ? 'true' : 'false'
          this.existingPhotos = Array.isArray(this.participant.baggagePhotos)
            ? this.participant.baggagePhotos.map(p => ({ ...p }))
            : []
        } else {
          this.form = this.getEmptyForm()
          this.hasAllergy = 'false'
          this.existingPhotos = []
        }
        this.errors = {}
        this.newPhotos.forEach(p => p.preview && URL.revokeObjectURL(p.preview))
        this.newPhotos = []
        this.removedPublicIds = []
      }
      this.closeLightbox()
    }
  },
  beforeUnmount() {
    this.closeLightbox()
  },
  methods: {
    getEmptyForm() {
      return { name: '', age: '', leader: '', number: '', numberFamily: '', city: '', church: '', allergy: '', baggage: '', quarto: '', celula: '', valorTotal: '', valorPago: '', dataPagamento: '', responsavel: '', contatoResponsavel: '' }
    },
    validate() {
      this.errors = {}
      if (!this.form.name || this.form.name.trim().length < 2) this.errors.name = 'Nome e obrigatorio (min 2 caracteres)'
      return Object.keys(this.errors).length === 0
    },
    async onPhotoSelected(event) {
      const file = event.target.files[0]
      event.target.value = ''
      if (!file || this.totalPhotos >= 2) return
      try {
        const normalized = await this.normalizePhoto(file)
        const preview = URL.createObjectURL(normalized)
        this.newPhotos.push({ file: normalized, preview })
      } catch {
        const preview = URL.createObjectURL(file)
        this.newPhotos.push({ file, preview })
      }
    },
    openLightbox(src) {
      if (!src) return
      this.lightboxSrc = src
      document.addEventListener('keydown', this.onLightboxKeydown)
    },
    closeLightbox() {
      this.lightboxSrc = null
      document.removeEventListener('keydown', this.onLightboxKeydown)
    },
    onLightboxKeydown(event) {
      if (event.key === 'Escape') {
        event.stopPropagation()
        this.closeLightbox()
      }
    },
    removeExistingPhoto(idx) {
      const [removed] = this.existingPhotos.splice(idx, 1)
      if (removed?.url && removed.url === this.lightboxSrc) this.closeLightbox()
      if (removed?.publicId) this.removedPublicIds.push(removed.publicId)
    },
    removeNewPhoto(idx) {
      const [removed] = this.newPhotos.splice(idx, 1)
      if (removed?.preview && removed.preview === this.lightboxSrc) this.closeLightbox()
      if (removed?.preview) URL.revokeObjectURL(removed.preview)
    },
    normalizePhoto(file) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
          const maxSize = 1600
          let width = img.width
          let height = img.height
          if (width > maxSize || height > maxSize) {
            const ratio = Math.min(maxSize / width, maxSize / height)
            width = Math.round(width * ratio)
            height = Math.round(height * ratio)
          }
          const canvas = document.createElement('canvas')
          canvas.width = width
          canvas.height = height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          canvas.toBlob((blob) => {
            if (blob) resolve(new File([blob], `mala-${Date.now()}.jpg`, { type: 'image/jpeg' }))
            else reject(new Error('Canvas conversion failed'))
          }, 'image/jpeg', 0.85)
        }
        img.onerror = () => reject(new Error('Image load failed'))
        img.src = URL.createObjectURL(file)
      })
    },
    handleSubmit() {
      if (!this.validate()) return
      const data = { ...this.form }
      if (this.hasAllergy === 'false') data.allergy = ''
      this.$emit('save', {
        data,
        newPhotos: this.newPhotos.map(p => p.file),
        removedPublicIds: [...this.removedPublicIds]
      })
    }
  }
}
</script>

<style scoped>
.form-modal { max-width: 600px; }
.participant-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
}
.form-group { display: flex; flex-direction: column; }
.form-sm { max-width: 120px; }
.form-row { display: flex; gap: var(--spacing-base); }
.form-row .form-group { flex: 1; }
.textarea { min-height: 70px; resize: vertical; }
.radio-group { display: flex; gap: var(--spacing-base); margin-top: var(--spacing-sm); }
.radio-label {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  cursor: pointer;
}
@media (max-width: 496px) {
  .form-row { flex-direction: column; }
  .form-sm { max-width: 100%; }
}

/* Fotos da mala */
.baggage-photos {
  display: flex;
  gap: var(--spacing-sm);
  flex-wrap: wrap;
  margin-top: var(--spacing-xs);
}
.photo-slot {
  position: relative;
  width: 96px;
  height: 96px;
  border-radius: var(--radius-md);
  overflow: hidden;
  background: var(--color-bg-separator);
  flex-shrink: 0;
}
.photo-open {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  background: none;
  cursor: zoom-in;
}
.photo-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.photo-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0,0,0,0.65);
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}
.photo-remove:hover { background: rgba(0,0,0,0.85); }
.photo-add {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 2px dashed #bbb;
  background: transparent;
  color: var(--color-text-muted);
  cursor: pointer;
  font-size: var(--text-xs);
  transition: var(--transition-fast);
}
.photo-add:hover {
  border-color: var(--color-accent);
  color: var(--color-accent);
}
/* Lightbox */
.photo-lightbox {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-base);
  cursor: zoom-out;
}
.lightbox-image {
  max-width: 95vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-hover);
  cursor: default;
}
.lightbox-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}
.lightbox-close:hover { background: rgba(0, 0, 0, 0.9); }

.file-input-hidden {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}
</style>
